"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("react");
const jsonpath_1 = tslib_1.__importDefault(require("jsonpath"));
const use_debounce_1 = require("use-debounce");
const utils_1 = require("../utils");
const useProxy_1 = require("./useProxy");
const contentItemToData = (ci) => {
    return Object.entries(ci).reduce((acc, [cifKey, cifVal]) => {
        return Object.assign(Object.assign({}, acc), { [cifKey]: cifVal.data });
    }, {});
};
exports.useFilter = ({ toggleFailedToParse, contentMapping, proxyResult, }) => {
    const [{ filteredContentItems, parseError, filterIsPending }, setState,] = react_1.useState({
        filteredContentItems: null,
        filterIsPending: false,
        parseError: null,
    });
    // FILTER
    const [filterHandler, cancelFilter] = use_debounce_1.useDebouncedCallback(() => {
        if (!contentMapping || !contentMapping.pathToArray) {
            toggleFailedToParse(false);
            setState({
                filteredContentItems: null,
                filterIsPending: false,
                parseError: null,
            });
        }
        try {
            const filteredItems = jsonpath_1.default.query(proxyResult.data && proxyResult.data.proxy
                ? proxyResult.data.proxy
                : {}, contentMapping.pathToArray);
            const filteredItemsContentItem = filteredItems
                ? utils_1.filterContentItems(filteredItems, contentMapping)
                : null;
            toggleFailedToParse(false);
            setState({
                filteredContentItems: filteredItemsContentItem && Array.isArray(filteredItemsContentItem)
                    ? filteredItemsContentItem.map(ci => {
                        return contentItemToData(ci);
                    })
                    : null,
                filterIsPending: false,
                parseError: null,
            });
        }
        catch (e) {
            toggleFailedToParse(true);
            setState({
                filteredContentItems: null,
                filterIsPending: false,
                parseError: e,
            });
        }
    }, useProxy_1.DEBOUNCE);
    react_1.useEffect(() => {
        setState({
            filteredContentItems,
            filterIsPending: true,
            parseError,
        });
        filterHandler();
    }, [proxyResult && proxyResult.data, contentMapping]);
    // const newFilteredContentItems = useMemo(() => {
    //   if (filteredContentItems) {
    //     try {
    //       return contentMapping.fields.reduce((obj, field) => {
    //         return jsonpath.query(obj, field.path);
    //       }, []);
    //       // return;
    //     } catch (e) {
    //       return filteredContentItems;
    //     }
    //   }
    //   return filteredContentItems;
    // }, [contentMapping, filteredContentItems]);
    return {
        cancelFilter,
        filteredContentItems,
        filterIsPending,
        parseError,
    };
};
//# sourceMappingURL=useFilter.js.map